import { StorageManager } from "@aws-amplify/ui-react-storage";
import { Storage } from "aws-amplify";
import { useRef } from "react";
import { UseFormSetValue } from "react-hook-form";

interface FileUploaderInputProps {
  pathPrefix: string;
  name: string;
  setImagePreview: any;
  setImageUploadDescription: (file: File) => void;
  setValue: UseFormSetValue<any>;
}

function FileUploaderInput({
  pathPrefix,
  name,
  setImagePreview,
  setImageUploadDescription,
  setValue,
}: FileUploaderInputProps) {
  const refFileUploader = useRef<{ clearFiles: () => void } | null>(null);

  const fetchImages = async (key: string) => {
    /* Fetch data from resize folder */
    const { results } = await Storage.list(key, {
      level: "public",
      pageSize: 50,
    });

    const resultFilters = results.filter((coverKey) => coverKey.size! > 0);
    const signedUrl = resultFilters.map(async (image: any) => {
      const res = await Storage.get(image.key!, { level: "public" });
      return { key: image.key!, signedUrl: res };
    });
    const s3ImagesPromise = await Promise.allSettled(signedUrl);
    setImagePreview(s3ImagesPromise);
  };

  const processFile = async ({ file }: { file: File }) => {
    const fileExtension = file.name.split(".").pop();
    setImageUploadDescription(file);
    return file
      .arrayBuffer()
      .then((filebuffer) => window.crypto.subtle.digest("SHA-1", filebuffer))
      .then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
          .map((a) => a.toString(16).padStart(2, "0"))
          .join("");
        return { file, key: `${hashHex}.${fileExtension}` };
      });
  };

  return (
    <StorageManager
      acceptedFileTypes={[
        // you can list file extensions:
        ".png",
        ".jpeg",
        ".jpg",
        // or MIME types:
        "image/png",
        "image/jpeg",
        "image/jpg",
      ]}
      accessLevel="public"
      maxFileCount={1}
      showThumbnails={true}
      path={pathPrefix}
      maxFileSize={20000000}
      ref={refFileUploader}
      processFile={processFile}
      displayText={{
        // some text are plain strings
        dropFilesText: "Drag and Drop or Choose a Local File",
        // browseFilesText: 'Open file picker',
        // other are functions that take an argument
        getFilesUploadedText(count) {
          return `${count} images uploaded`;
        },
      }}
      onUploadSuccess={({ key }) => {
        setValue(name, key);
        setTimeout(() => {
          fetchImages(key as string);
          if (refFileUploader) refFileUploader.current?.clearFiles();
        }, 1000);
      }}
    />
  );
}
export default FileUploaderInput;
